import { apiPaths } from '../../config'
import { http, notification } from '../../services/index'
import { factorySetStateAction } from '../factory'

const actions = {
  SET_STATE: 'clinicPatient/SET_STATE',
  GET_CLINIC_PATIENTS: 'clinicPatient/GET_CLINIC_PATIENTS',
  ADD_CLINIC_PATIENT: 'clinicPatient/ADD_CLINIC_PATIENT',
  GET_PATIENT_PROFILE: 'clinicPatient/GET_PATIENT_PROFILE',
  GET_PATIENT_BODY_CLOCK: 'clinicPatient/GET_PATIENT_BODY_CLOCK',
  GET_AVAILABLE_DEVICES: 'clinicPatient/GET_AVAILABLE_DEVICES',
  UNASSIGN_DEVICE: 'clinicPatient/UNASSIGN_DEVICE',
  GET_PATIENT_DETAIL: 'clinicPatient/GET_PATIENT_DETAIL',
  UPDATE_PATIENT: 'clinicPatient/UPDATE_PATIENT',
  DELETE_PATIENT: 'clinicPatient/DELETE_PATIENT',
  DISCHARGE_PATIENT: 'clinicPatient/DISCHARGE_PATIENT',
  READMIT_PATIENT: 'clinicPatient/READMIT_PATIENT',
  GET_PATIENT_IDS: 'clinicPatient/GET_PATIENT_IDS',
  DELETE_MULTIPLE_PATIENT: 'clinicPatient/DELETE_MULTIPLE_PATIENT',
  STORE_CHANGE_NOTES: 'clinicPatient/STORE_CHANGE_NOTES',
  GET_CHANGE_STATUSES_LOGS: 'clinicPatient/GET_CHANGE_STATUSES_LOGS',
}

export const clinicPatientSetState = factorySetStateAction(actions.SET_STATE)

export const getClinicPatients = async (role, data) =>
  http
    .get(apiPaths[role].apiPatientListDB, data, {})
    .then((res) => res)
    .catch(() => [])

export const getClinicPatientDetail = async (role, data) =>
  http
    .get(apiPaths[role].apiPatientListDB, data, {})
    .then((res) => res)
    .catch(() => [])

export const addClinicPatient = (dataObj, role, isUpdate = false) =>
  http
    .post(
      isUpdate
        ? `${apiPaths[role].apiPatientAddUpdate}/${dataObj.id}`
        : apiPaths[role].apiPatientAddUpdate,
      dataObj,
      {},
    )
    .then((res) => {
      notification.success(`Success`, 'Resident Added Successfully')
      return { res, success: true }
    })
    .catch((err) => {
      const { response } = err
      notification.error(
        `Something went wrong`,
        `${response && response.data ? response.data : err}`,
      )
      return { success: false }
    })

export const getAvailableDevices = async (role, data) =>
  http
    .get(
      apiPaths[role].apiAvailableDevicesList !== undefined
        ? apiPaths[role].apiAvailableDevicesList
        : '', // YQ: ???????
      data,
      {},
    )
    .then((res) => res)
    .catch(() => []) // YQ: catch

export const unassignDeviceFromPatient = async (role, data, showNotification = true) =>
  http
    .get(
      apiPaths[role].apiUnassignDevice !== undefined ? apiPaths[role].apiUnassignDevice : '', // YQ: empty sring ???????
      data,
      {},
    )
    .then((res) => {
      if (showNotification) {
        notification.success(`Success`, 'Device unassigned successfully')
      }
      return { res, success: true }
    })
    .catch((err) => {
      const { response } = err
      window.log('response', JSON.stringify(response))
      notification.error(
        `Something went wrong`,
        `${response && response.data ? response.data : err}`,
      )
      return { success: false }
    })

export const updatePatient = async (role, data, showNotification = true) =>
  http
    .post(apiPaths[role].apiPatientUpdate, data, {})
    .then((res) => {
      if (showNotification) {
        notification.success(`Success`, 'Resident Updated Successfully')
      }
      return { res, success: true }
    })
    .catch((err) => {
      const { response } = err
      notification.error(
        `Something went wrong`,
        `${response && response.data ? response.data : err}`,
      )
      return { success: false }
    })

export const dischargePatient = async (role, data, showNotification = true) =>
  http
    .post(apiPaths[role].apiDischargeStatus, data, {})
    .then((res) => {
      if (showNotification) {
        notification.success(`Success`, 'Resident discharge Successfully')
      }
      return { res, success: true }
    })
    .catch((err) => {
      const { response } = err
      window.log('response', JSON.stringify(response))
      notification.error(
        `Something went wrong`,
        `${response && response.data ? response.data : err}`,
      )
      return { success: false }
    })

export const reAdmitPatient = async (role, data, showNotification = true) =>
  http
    .post(apiPaths[role].apiDischargeStatus, data, {})
    .then((res) => {
      if (showNotification) {
        notification.success(`Success`, 'Resident readmitted successfully')
      }
      return { res, success: true }
    })
    .catch((err) => {
      const { response } = err
      notification.error(
        `Something went wrong`,
        `${response && response.data ? response.data : err}`,
      )
      return { success: false }
    })

export const deleteMultiplePatient = async (role, data) =>
  http
    .post(apiPaths[role].apiPatientStatus, data, {})
    .then(() => {
      notification.success(
        `Success`,
        `Resident ${data.status === 0 ? '' : 'Undo '}Deleted Successfully`,
      )
      return { success: true }
    })
    .catch((err) => {
      const { response } = err
      notification.error(
        `Unable to Delete Resident`,
        `${response && response.data ? response.data : err}`,
      )
      return { success: false }
    })

export const deletePatient = async (role, data) =>
  http
    .post(apiPaths[role].apiPatientDelete, data, {})
    .then((res) => res)
    .catch(() => [])

export const getPatientIdsForDevice = async (role, data) =>
  http
    .get(apiPaths[role].apiPatientIds !== undefined ? apiPaths[role].apiPatientIds : '', data, {})
    .then((res) => ({ response: res, success: true }))
    .catch((err) => {
      const { response } = err
      notification.error('', `${response && response.data ? response.data : err}`)
      return { response: err, success: false }
    })

export const getPatientAssignedDevices = (role, data) =>
  http
    .get(apiPaths[role].apiPatientDevicesData, data, {})
    .then((res) => res)
    .catch((err) => {
      window.log(err)
      return []
    })

export const setDevicesToPatient = (role, data) =>
  http
    .post(apiPaths[role].apiPatientDeviceTransfer, data, {})
    .then((res) => ({ success: true, response: res }))
    .catch((err) => {
      if (err.response && Array.isArray(err.response.data)) {
        return { success: false, data: err.response.data.filter((r) => r.patient_id) }
      }
      return {
        success: false,
        data: err && err.response && err.response.data ? err.response.data : '',
      }
    })

export const getStatusList = async (role) =>
  http
    .get(apiPaths[role].apiStatusList, {}, {})
    .then((res) => res)
    .catch(() => [])

export const getStatusesLogs = async (role, data = {}) =>
  http
    .get(apiPaths[role].apiStatusesLogs, data, {})
    .then((res) => res)
    .catch(() => [])

export const storeResidentChangeNote = async (role, payload) =>
  http
    .put(`${apiPaths[role].apiStoreChangeNote}/${payload.patient_id}`, payload, {})
    .then(() => 'success') // YQ: ??
    .catch(() => [])

export const verifyPasswordForApproval = (data) =>
  http
    .post(apiPaths.Clinic.apiVerifyPassword, data, {})
    .then((res) => res)
    .catch(() => {
      notification.error(`Invalid Password`)
    })

export const getClinicPatientsAction = (payload) => ({
  type: actions.GET_CLINIC_PATIENTS,
  payload,
})

export const getAvailableDevicesAction = (payload) => ({
  type: actions.GET_AVAILABLE_DEVICES,
  payload,
})

export default actions
